import { render, staticRenderFns } from "./DashboardKpiCards.vue?vue&type=template&id=4c32bf6d&"
import script from "./DashboardKpiCards.vue?vue&type=script&lang=js&"
export * from "./DashboardKpiCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports